import {Box} from '@viptech/react-components'
import {Layers, Repeat, Search} from 'lucide-react'
import {Input, InputGroup, InputIconLeft} from 'src/components/new-input/input'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {useCompaniesSelector} from 'src/layouts/main-layout/companies-selector/companies-selector-context'

export function CompaniesSelectorNav() {
  const {search, setSearch, activeTab, setActiveTab} = useCompaniesSelector()
  const {styledTheme} = usePersonalizedThemeByCompany()

  const tabs = [
    {id: 'radio', label: <Repeat className='size-4' />},
    {id: 'switch', label: <Layers className='size-4' />},
  ]

  return (
    <div className='flex gap-3 p-3 items-center'>
      <InputGroup className=''>
        <InputIconLeft>
          <Search className='size-5' />
        </InputIconLeft>
        <Input
          placeholder='Procurar'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className='h-9 border-transparent bg-[#46556966] pl-11 text-sm'
        />
      </InputGroup>

      <Box height={'38px'} borderRadius={'8px'} display='flex' align='center' justifyContent='center' backgroundColor='#334155' padding='1px 5px'>
        {tabs.map((option) => {
          return (
            <Box key={option.id} display='flex' direction='column' align='center' width='100%' justifyContent='center' onClick={() => setActiveTab(option.id)}>
              <span
                style={{
                  backgroundColor: activeTab === option.id ? styledTheme.colors.white : '#334155',
                  cursor: 'pointer',
                  padding: '6px',
                  borderRadius: '6px',
                  color: activeTab === option.id ? '#334155' : styledTheme.colors.white,
                }}
                onClick={() => setActiveTab(option.id)}>
                {option.label}
              </span>
            </Box>
          )
        })}
      </Box>
    </div>
  )
}
